import { render, staticRenderFns } from "./FabricAnalytics.vue?vue&type=template&id=6055e4be&scoped=true"
import script from "./FabricAnalytics.vue?vue&type=script&lang=js"
export * from "./FabricAnalytics.vue?vue&type=script&lang=js"
import style0 from "./FabricAnalytics.vue?vue&type=style&index=0&id=6055e4be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6055e4be",
  null
  
)

export default component.exports